/* eslint-disable consistent-return */
/* eslint-disable import/prefer-default-export */
import fetch from 'isomorphic-unfetch';

import config from '../../config';

const { apiHost } = config;

export const fetchPtsEvents = () => async (dispatch) => {
    dispatch({ type: 'PTS_EVENT:FETCH_CONTENT_REQUEST' });
    try {
        return await fetch(
            `${apiHost}/v2/search/events?tours=UTR+Pro+Tennis+Tour`,
        )
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    dispatch({
                        type: 'PTS_EVENT:FETCH_CONTENT_FAILURE',
                        data: data.error,
                    });
                } else {
                    dispatch({
                        type: 'PTS_EVENT:FETCH_CONTENT_SUCCESS',
                        data,
                    });
                }
            });
    } catch (error) {
        dispatch({ type: 'PTS_EVENT:FETCH_CONTENT_FAILURE' });
        console.log('error fetch pts events', error);
    }
};

export const fetchPtsEventsV2 = ({ start, end, tourType, eventState, gender }) => async (dispatch) => {
    dispatch({ type: 'PTS_EVENT:FETCH_CONTENT_REQUEST' });
    try {
        const params = new URLSearchParams();

        if (start && end) {
            params.append('range', `eventSchedule.eventStartUtc>=${start}`);
            params.append('range', `eventSchedule.eventStartUtc<=${end}`);
        }
        if (eventState) {
            params.append('eventState', `${eventState}`);
        }
        if (gender) {
            params.append('genders', `${gender}`);
        }

        params.append('top', '250');
        params.append('skip', '0');

        return await fetch(
            `${apiHost}/v2/search/events?tours=${tourType || 'UTR+Pro+Tennis+Tour'}&${params.toString()}`,
        )
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    dispatch({
                        type: 'PTS_EVENT:FETCH_CONTENT_FAILURE',
                        data: data.error,
                    });
                } else {
                    dispatch({
                        type: 'PTS_EVENT:FETCH_CONTENT_SUCCESS',
                        data: data.hits.map(({ source }) => ({
                            ...source,
                        })),
                    });
                }
            });
    } catch (error) {
        dispatch({ type: 'PTS_EVENT:FETCH_CONTENT_FAILURE' });
        console.log('error fetch pts events', error);
    }
};
